class SelectResourceUsersController {
  static controller ($scope, $rootScope, $state, $timeout, $mdDialog, ResourceService, $translate) {
    'ngInject';
    this.searchVisible = false;
    $scope.resourceSearch = {name: ''};

    $scope.toggleSearch = function () {
      this.searchVisible = !this.searchVisible;
      $scope.resourceSearch.name = '';

      if(this.searchVisible) {
        document.querySelector('#searchInput').focus();
      }
    };
    $scope.selectedResource = undefined;

    $scope.selectResource = function (resource) {
      if($scope.selectedResource === resource) {
        $scope.selectedResource = undefined;
      } else {
        $scope.selectedResource = resource;
      }

      loginToResource($scope.selectedResource);

    };

    let loginCount = 0;

    $scope.resources = [];
    loadResources();

    function loginToResource(resource){
      $rootScope.mainProgressVisible = true;
      var promise = ResourceService.login($rootScope.auth.login, resource);

      promise.then(function(data) {
        var stateName = 'protected.users.resource.' + resource.resourceType;
        $rootScope.mainProgressVisible = false;
        $state.go($state.get(stateName) ? stateName : 'protected.users.resource.notFound');
      });
    }


    $scope.showAllResources = function(ev, resources) {
      $mdDialog.show({
        controller: function DialogController($scope, $mdDialog) {
          'ngInject';
          $scope.resources = resources;

          $scope.onSelected = function (resource) {
            $mdDialog.hide(resource);
          };

          $scope.hide = function() {
            $mdDialog.hide();
          };

          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },
        template: require('./all-resources.modal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: true
      })
      .then(function(selectedResource) {
        loginToResource(selectedResource);
      });
    };

    $scope.removeResource = function(uniqueId) {
      ResourceService.removeResource(uniqueId)
      .then(() => {
        loadResources();
      });
    }

    function loadResources (){
      var promise = ResourceService.loadCurrentUserResources($rootScope.auth.login);
      promise.then(function(data) {
        $scope.resources = data.resources;
        ResourceService.setCurrentUserResources(data.resources);
      });
    }
  };
}

export default SelectResourceUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/select-resource.users.controller.js